import React, { useState, useContext } from "react";
import { Card, Flex, Button, Image } from "rebass";
import { Input, Label } from "@rebass/forms";
import styled from "styled-components";
import { AuthContext } from "../Contexts";
import { HR } from "../Components";

export const Login: React.FC = () => {
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");

  const authContext = useContext(AuthContext);

  const onKeyPress = (e)=>{
    if(e.charCode === 13)
      authContext.logIn(userName, password);
  };

  return (
    <Container justifyContent="center" alignItems="center">
      <LoginCard>
        <Image width="200px" src="/vivid_vision_logo.png" alt="logo" />
        <HR />
        <form>
          <Label htmlFor="username">Username</Label>
          <Input
            value={userName}
            id="username"
            onChange={(e) => {
              setUserName(e.target.value);
            }}
            onKeyPress={onKeyPress}
          />
          <Label htmlFor="password">Password</Label>
          <Input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            onKeyPress={onKeyPress}
            id="password"
          />
          <Button
            type="button"
            disabled={authContext.loading}
            onClick={() => {
              authContext.logIn(userName, password);
            }}
          >
            Login
          </Button>
        </form>
      </LoginCard>
    </Container>
  );
};

const LoginCard = styled(Card)`
  min-width: 300px;
  max-width: 400px;
  width: 100%;
`;

const Container = styled(Flex)`
  height: 100vh;
  width: 100vw;
`;
